import ukGovLogo from "../icons/uk_gov_logo.png";

const UKRibbon = () => {
  return (
    <header
      className="bg-black text-white p-2"
      style={{
        height: "56px",
      }}
    >
      <div className="flex">
        <div className="flex-initial">
          <img className="w-12 h-10" src={ukGovLogo} alt="" />
        </div>
        <div className="truncate flex-initial py-3 sm:py-2 lg:py-2 ml-2">
          <p className="text-xs sm:text-base">
            Department for Environment Food & Rural Affairs
          </p>
        </div>
      </div>
    </header>
  );
};

export default UKRibbon;
